import React, { useState, useEffect } from 'react';
import EditDeleteTable from '../Components/EditDeleteTable';
import DeleteModal from '../Components/DeleteModal';
import styles from '../Styles/ViewOfUsersPages.module.css';
import { useAuth } from '../Components/AuthContext';

// A dummy modal so EditDeleteTable’s EditModal prop is satisfied
const NoOpModal = ({ open, onClose }) => null;

function ViewOfInstitutions() {
    const [rows, setRows] = useState([]);
    const [errorMessage, setErrorMessage] = useState(null);
    const url = process.env.REACT_APP_API_URL;
    const { token } = useAuth();

    // Fetch institution accounts
    const fetchInstitutions = async () => {
        try {
            const res = await fetch(`${url}/institution-account/list`);
            if (!res.ok) throw new Error('Network response was not ok');
            const data = await res.json();
            setRows(data);
        } catch (err) {
            console.error('Error fetching institutions:', err);
            setErrorMessage('Failed to load institutions');
        }
    };

    useEffect(() => {
        fetchInstitutions();
    }, []);

    // Table columns
    const columns = [
        {
            field: 'institution_name',
            headerName: 'Institution Name',
            width: 250,
            flex: 1,
        },
        { field: 'email', headerName: 'Email', width: 300, flex: 1 },
    ];

    // Delete handler
    const deleteInstitution = async (id) => {
        try {
            const res = await fetch(`${url}/institution-account/${id}`, {
                method: 'DELETE',
                headers: {
                    'Content-Type': 'application/json',
                    Authorization: `Bearer ${token}`,
                },
            });
            if (!res.ok) throw new Error('Failed to delete institution');
            fetchInstitutions();
        } catch (err) {
            console.error('Error deleting institution:', err);
        }
    };

    return (
        <div className={styles.viewOfUsersContainer}>
            <h2>Institutions</h2>

            {errorMessage && <div className="alert error">{errorMessage}</div>}

            <div className={styles.tableWrapper}>
                <EditDeleteTable
                    rows={rows}
                    columns={columns}
                    editModal={NoOpModal} // no editing
                    deleteModal={DeleteModal}
                    showEditButton={false}
                    showDeleteButton={true}
                    customConfirmMessage={(row) =>
                        row?.institution_name || 'this institution'
                    }
                    onConfirmDelete={deleteInstitution}
                />
            </div>
        </div>
    );
}

export default ViewOfInstitutions;
